import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function Section({ title, subtitle, to, actionLabel = "View all", children, testid, linkTestId }) {
  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="flex items-end justify-between">
        <div>
          <h3 className="text-base font-bold text-slate-900 leading-tight">{title}</h3>
          {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
        {to && (
          <Link
            to={to}
            data-testid={linkTestId}
            className="text-xs font-semibold text-emerald-600 hover:text-emerald-700 flex items-center gap-0.5 transition"
          >
            {actionLabel} <ArrowRight className="w-3 h-3" strokeWidth={2.6} />
          </Link>
        )}
      </div>
      {children}
    </div>
  );
}

export function EmptyState({ Icon, title, subtitle, action, testid }) {
  return (
    <div
      data-testid={testid || "vc-empty-state"}
      className="text-center py-10 bg-white rounded-2xl border border-dashed border-slate-200"
    >
      {Icon && (
        <div className="w-14 h-14 rounded-full bg-slate-50 mx-auto grid place-items-center mb-3">
          <Icon className="w-7 h-7 text-slate-400" strokeWidth={2.2} />
        </div>
      )}
      <p className="text-sm font-semibold text-slate-800 mb-0.5">{title}</p>
      {subtitle && <p className="text-xs text-slate-500 mb-3">{subtitle}</p>}
      {action}
    </div>
  );
}

export function SkeletonRow({ height = "h-20" }) {
  return <div className={`${height} rounded-2xl bg-slate-100 animate-pulse`} />;
}

export function SkeletonList({ count = 3, height = "h-20" }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonRow key={i} height={height} />
      ))}
    </div>
  );
}
